import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'exposure-minus-1', 'ExposureMinus1', [["path",{"d":"M3 12h6"}],["path",{"d":"M18 19v-14l-4 4"}]]);